import { useMemo } from 'react'

/**
 * 判断当前环境是否支持 0.5px 边框？
 */
export function useSupportHairline() {
  const supportHairline = useMemo(() => {
    let result = false
    if (window.devicePixelRatio >= 2) {
      const testElem = document.createElement('div')
      testElem.style.border = '.5px solid transparent'
      document.body.appendChild(testElem)

      if (testElem.offsetHeight === 1) {
        result = true
      }
      document.body.removeChild(testElem)
    }
    return result
  }, [])

  return { supportHairline }
}
